import { StreetTypeRepository, StreetType, StreetTypeName } from '@/Domain/Localization/StreetType'
import { LanguageCode } from '@/Domain/Localization'

const esStreetTypes = [
  new StreetType('1', new StreetTypeName('Avenida')),
  new StreetType('2', new StreetTypeName('Carretera')),
  new StreetType('3', new StreetTypeName('Camino')),
  new StreetType('5', new StreetTypeName('Calle'))
]
const glStreetTypes = [
  new StreetType('1', new StreetTypeName('Avenida')),
  new StreetType('2', new StreetTypeName('Estrada')),
  new StreetType('3', new StreetTypeName('Camiño')),
  new StreetType('5', new StreetTypeName('Rúa'))
]
async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
export class InMemoryStreetTypeRepository implements StreetTypeRepository {
  async byLanguageCode (languageCode: LanguageCode): Promise<StreetType[]> {
    await wait(400)
    if (languageCode === 'es') {
      return esStreetTypes
    }
    return glStreetTypes
  }
}
